import { ApolloProvider } from '@apollo/client/react';
import {
  ErrorBoundary,
  PageGuidanceBanner,
  PermissionTypes,
  authUtils,
  client,
} from 'fso-fincrime-sdk-ui';
import { createBrowserHistory } from 'history';
import { useEffect } from 'react';
import { useParams } from 'react-router';

import TaskList from './work-items/TaskList';
import ChartDisplay from '../components/task-list/chart-carousel/ChartCarousel';
import IInbox from '../ts/entities/pages/inbox/IInbox';
import { CONSTANTS } from '../utils/constants/constants';

const Inbox = ({ withChart }: IInbox): JSX.Element => {
  const params = useParams();
  const history = createBrowserHistory();
  const canSeeCards = authUtils.checkUserPermissions(PermissionTypes.CHART_CARD);
  const canSeeTaskCharts = authUtils.checkUserPermissions(PermissionTypes.CHART_TASK);

  useEffect(() => {
    //Add title to the browser tab
    document.title = 'Fin Crime 3.0 ';
  }, []);

  return (
    <>
      <PageGuidanceBanner page={CONSTANTS.TASK_LIST} />

      <div className="padding-top-20 custom-container show-scroll">
        <ApolloProvider client={client}>
          {(canSeeCards || canSeeTaskCharts) && withChart && (
            <ErrorBoundary history={history} params={params}>
              <ChartDisplay />
            </ErrorBoundary>
          )}
          <ErrorBoundary history={history} params={params}>
            <TaskList />
          </ErrorBoundary>
        </ApolloProvider>
      </div>
    </>
  );
};

export default Inbox;
